export default "__VITE_ASSET__CbVqXtPf__"